export default function apiUrlBuilder(apiBaseUrl: string, fileUrl: string) {
  try {
    return new URL(fileUrl).toString();
  } catch (e) {
    return new URL(`${apiBaseUrl}${fileUrl}`).toString();
  }
}
